import { makeAutoObservable } from 'mobx';
import SearchPropertyViewState from './SearchPropertyViewState';

class SearchState {
  constructor() {
    makeAutoObservable(this);
  }

  init() {}

  destroy() {}
}

const state = new SearchState();
const searchPropertyViewState = new SearchPropertyViewState();

const useSearchState = () => state;
const useSearchPropertyViewState = () => searchPropertyViewState;

export default state;
export { useSearchPropertyViewState, useSearchState };
